import { z } from 'zod';
export const fundHolidayIdSchema = z
    .string()
    .min(1)
    .max(50)
    .regex(/^[A-Za-z0-9_-]+$/);
export const createFundHolidaysSchema = z.object({
    date: z.iso.date(),
    comment: z.string().trim().default(''),
    fund_ids: z
        .array(z.number().int().positive())
        .min(1)
        .refine((ids) => new Set(ids).size === ids.length, {
        message: 'Select each fund only once.',
    }),
});
export const getFundHolidaysSchema = z
    .object({
    fund_ids: z
        .array(z.number().int().positive())
        .min(1)
        .transform((ids) => [...new Set(ids)].sort((a, b) => a - b)),
    st_dt: z.iso.date(),
    ed_dt: z.iso.date(),
})
    .refine(({ st_dt, ed_dt }) => st_dt <= ed_dt, {
    message: 'Start date must be on or before end date.',
    path: ['ed_dt'],
});
export const createFundSchema = z.object({
    fund_name: z.string().min(1),
    currency: z.string().min(1),
    fund_long_name: z.string().min(1),
    platform_name: z.string().optional(),
});
export const updateNavEntrySchema = z.object({
    rowData: z.unknown(),
    oldValue: z.unknown(),
    newValue: z.unknown(),
    updatedField: z.string(),
});
export const deleteNavEntrySchema = z.object({
    value_date: z.string(),
    fund_name: z.string(),
});
